import BaseController from "confinus_ui/base_controller";

export default class BreadcrumbsController extends BaseController {
  public mobileSelectChanged(event: Event) {
    const target = event.target as HTMLSelectElement;
    const value = target.value;
    window.location.href = value;
  }
}
